const STORAGE_KEY = "filter_sidebar_open";
const MOBILE_BREAKPOINT = 768;

export class FilterSidebarToggleHandler {
    public isMobile(): boolean {
        return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    public readStoredState(): boolean {
        try {
            return localStorage.getItem(STORAGE_KEY) !== "0";
        } catch {
            return true;
        }
    }

    public isOpen(wrapper: HTMLElement): boolean {
        return wrapper.dataset.sidebarOpen === "1";
    }

    public applyState(
        wrapper: HTMLElement,
        btn: HTMLElement | null,
        mobileBtn: HTMLElement | null,
        open: boolean,
    ): void {
        wrapper.dataset.sidebarOpen = open ? "1" : "0";
        btn?.classList.toggle("is-active", open);
        mobileBtn?.classList.toggle("is-active", open);
        if (!this.isMobile()) {
            try {
                localStorage.setItem(STORAGE_KEY, open ? "1" : "0");
            } catch {
                // ignore storage errors
            }
        }
    }

    // CSS uses !important on transform/transition for the mobile bottom-sheet
    // states, so the inline override must also carry "important" priority to
    // actually win the cascade. Passing null removes the inline override.
    public setSidebarTransitionOverride(sidebar: HTMLElement, value: string | null): void {
        if (value === null) {
            sidebar.style.removeProperty("transition");
        } else {
            sidebar.style.setProperty("transition", value, "important");
        }
    }

    public setSidebarDragOffset(sidebar: HTMLElement, deltaPx: number | null): void {
        if (deltaPx === null) {
            sidebar.style.removeProperty("transform");
        } else {
            sidebar.style.setProperty("transform", `translateY(${deltaPx}px)`, "important");
        }
    }
}
